<template>
    <div class="box" :style="{ height: height + 'px' }">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane lazy v-for="item in list" :key="item.name" :name="item.name" :label="item.label">
                <CloseAccountVue v-if="item.name == 1" ref="close"></CloseAccountVue>
                <CheckAccountVue v-if="item.name == 2" ref="check"></CheckAccountVue>
                <ClearAccountVue v-if="item.name == 3" ref="clear"></ClearAccountVue>
            </el-tab-pane>

        </el-tabs>
    </div>
</template>

<script>
import CheckAccountVue from './checkAccount.vue';
import ClearAccountVue from './clearAccount.vue';
import CloseAccountVue from './closeAccount.vue';
export default {
    data() {
        return {
            height: 0,
            activeName: '1',
            list: [
                { label: '结算', name: '1' },
                { label: '对账', name: '2' },
                { label: '清算', name: '3' },
            ]
        }
    },
    components: {
        CheckAccountVue,
        ClearAccountVue,
        CloseAccountVue,

    },
    created() {
        this.height = document.documentElement.clientHeight - 77;
    },
    methods: {
        handleClick(tab) {
            switch (tab.name) {
                case '1':
                    this.$nextTick(() => {
                        this.$refs.close[0].init()
                    })
                    break;
                case '2':
                    this.$nextTick(() => {
                        this.$refs.check[0].init()
                    })
                    break;
                case '3':
                    this.$nextTick(() => {
                        this.$refs.clear[0].init()
                    })
                    break;
            }
        }
    }

}
</script>

<style lang="less" scoped>
.box {
    background-color: #fff;
    border-radius: 2px;
}

/deep/.el-tabs {
    border: none;
    border-bottom: 1px solid #EBEAEE;

}

/deep/ .el-tabs .el-tabs__content {
    display: block;
    padding: 16px;
    box-sizing: border-box;
}
</style>